export default __webpack_public_path__ + "static/media/driver_wait_confirm.8bad0609.svg";